import React, { useState } from 'react';
import { apiBaseUrl } from "../Globals";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Registration = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [isFinished, setIsFinished] = useState(false);
    const [agreedToRules, setAgreedToRules] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!email || !password) {
            setError(t('user.registration.fillAllFields'));
            return false;
        }

        if (!agreedToRules) {
            setError(t('user.registration.mustAgreeToRules'));
            return false;
        }


        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);
        formData.append("rules", agreedToRules);
        formData.append("language", localStorage.getItem('i18nextLng'));

        try {
            const response = await fetch(`${apiBaseUrl}?tx_biathlonhub_api%5Baction%5D=registration`, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            if (result.success) {
                setIsFinished(true);
                setError(result.message || "Registration successful!");
            } else {
                setError(result.message || "Registration failed.");
            }
        } catch (e) {
            setError(t('user.registration.anErrorAppeared'));
        }
    };

    return (
        <div className="p-4 flex flex-col h-full">
            <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0 mb-4">
                {t("user.regirstation.headline")}
            </h1>

            <div className="grow overflow-y-auto overflow-x-hidden mx-auto max-w-[48rem] w-full">
                {(isFinished) ? (
                    <div className="flex flex-col gap-6">
                        {error && <div className="text-xl">{error}</div>}
                        <div className="px-2">
                            <Link to="/login" className="button-primary">{t('user.registration.login')}</Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                        {error && <div className="text-red-500 font-bold">{error}</div>}
                        <div className="flex flex-col gap-y-6 gap-x-2 md:flex-row md:items-end">
                            <div className="md:grow flex flex-col gap-2">
                                <label htmlFor="email" className="font-bold">
                                    {t("user.regirstation.email")}
                                </label>
                                <div className="form-input-wrap">
                                    <input
                                        type="email"
                                        inputMode="email"
                                        id="email"
                                        value={email}
                                        placeholder={t("user.regirstation.email")}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="!pr-8"
                                    />
                                </div>
                            </div>

                            <div className="md:grow flex flex-col gap-2">
                                <label htmlFor="password" className="font-bold">
                                    {t("user.regirstation.password")}
                                </label>
                                <div className="form-input-wrap">
                                    <input
                                        type="password"
                                        id="password"
                                        placeholder={t("user.regirstation.password")}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="!pr-8"
                                    />
                                </div>
                            </div>
                        </div>
                        <label className="flex gap-6 items-start cursor-pointer" htmlFor="rules">
                            <div className="form-input-checkbox relative flex items-center justify-center">
                                <input type="checkbox" id="rules" name="rules"
                                       required
                                       onChange={(e) => setAgreedToRules(e.target.checked)}
                                       className="peer absolute inset-0 opacity-0" />
                                <div className="relative peer-checked:bg-[var(--light-color)] w-4 h-4"></div>
                            </div>
                            <div>{t("user.registration.IAgreeWith")} <a href={t('links.dataprivacy')} target="_blank" className="underline">{t("user.registration.dataprivacy")}</a>.</div>
                        </label>

                        <div className="px-2">
                            <button className="button-primary">{t("user.regirstation.submit")}</button>
                        </div>
                        <div className="text-sm">
                            {t('user.registration.haveAnAcc')} <Link to="/login" className="underline">{t('user.registration.login')}</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default Registration;
